import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/pro-solid-svg-icons';

import { connect } from 'react-redux';

import AlternateRoyaltyModal from './modal';
import { USD } from 'helpers/formatters/number_formats';

export function AlternateRoyaltyTable({
  enabled,
  grossCommissionTotal,
  isParentCompanyUser,
  royaltyPercent,
}) {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="d-flex flex-column gap-3">
      <h6>Alternate Royalty</h6>
      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>Status</th>
              <th className="text-end">YTD Gross Commission</th>
              <th className="text-end">Royalty Percentage</th>
              {isParentCompanyUser && <th/>}
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>{enabled ? 'Enabled' : 'Disabled'}</td>
              <td className="text-end">
                {USD.format(grossCommissionTotal)}
              </td>
              <td className="text-end">
                {enabled && royaltyPercent != null ? `${royaltyPercent}%` : '--'}
              </td>
              {isParentCompanyUser &&
                <td style={{ width: 0 }}>
                  <button
                    className="btn btn-link p-0 text-nowrap"
                    name="show-modal-link"
                    type="button"
                    onClick={() => setShowModal(true)}
                  >
                    <FontAwesomeIcon fixedWidth icon={faEdit} /> Edit
                  </button>
                </td>
              }
            </tr>
          </tbody>
        </table>
      </div>

      {isParentCompanyUser && <AlternateRoyaltyModal show={showModal} onClose={() => setShowModal(false)} />}
    </div>
  );
}

AlternateRoyaltyTable.propTypes = {
  enabled: PropTypes.bool,
  grossCommissionTotal: PropTypes.number,
  isParentCompanyUser: PropTypes.bool,
  royaltyPercent: PropTypes.number,
};

const mapStateToProps = ({ alternateRoyalty, isParentCompanyUser }) => ({
  enabled: alternateRoyalty.enabled,
  grossCommissionTotal: alternateRoyalty.grossCommissionTotal,
  isParentCompanyUser,
  royaltyPercent: alternateRoyalty.royaltyPercent,
});

export default connect(mapStateToProps)(AlternateRoyaltyTable);
